import { render, staticRenderFns } from "./drag-mode.vue?vue&type=template&id=270388d7&scoped=true&"
import script from "./drag-mode.vue?vue&type=script&lang=ts&"
export * from "./drag-mode.vue?vue&type=script&lang=ts&"
import style0 from "./drag-mode.vue?vue&type=style&index=0&id=270388d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270388d7",
  null
  
)

export default component.exports